import * as ErrorMessages from './errorMessages';
import * as checkIBAN from 'iban';
import * as EmailValidator from 'email-validator';
import moment from 'moment';

export const required = (text) => {
  if (text) {
    return null;
  } else {
    return ErrorMessages.isRequired;
  }
};

export const requiredMinor = (text, state) => {
  if (state.minor) {
    if (text) {
      return null;
    } else {
      return ErrorMessages.isRequired;
    }
  } else {
    return null;
  }
};

export const requiredIBAN = (text, state) => {
  if (state.IBAN === "") {
    return null;
  } else {
    if (text) {
      return null;
    } else {
      return ErrorMessages.isRequiredIBAN;
    }
  }
};

export const validDate = text => {
  var formattedText = (text.includes('-')) ? text : text.split('/').reverse().join("-")
  var date = moment(formattedText, 'YYYY-MM-DD', true)

  if (text && (text.length !== 10 || !date.isValid())) {
    return ErrorMessages.validDate
  }

  return null
}

export const validDateRange = text => {
  var formattedText = (text.includes('-')) ? text : text.split('/').reverse().join("-")
  var date = moment(formattedText, 'YYYY-MM-DD', true)

  if (text && moment().diff(date, 'days') < 0) {
    return ErrorMessages.futureDate
  } else if (text && moment().diff(date, 'years') > 150) {
    return ErrorMessages.pastDate
  }

  return null

}

export const minLength = (length) => {
  return (text) => {
    return text.length >= length ? null : ErrorMessages.minLength(length);
  };
};

export const maxLength = (length) => {
  return (text) => {
    return text.length <= length ? null : ErrorMessages.maxLength(length);
  };
};

export const mustMatch = (field, fieldName) => {
  return (text, state) => {
    return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
  };
};

export const mustNotMatch = (field, fieldName) => {
  return (text, state) => {
    return state[field] !== text ? null : ErrorMessages.mustNotMatch(fieldName);
  };
};

export const number = (text) => {
  var numberTest = /^\d+$/
  if (text) {
    if (numberTest.test(text)) {
      return null;
    } else {
      return ErrorMessages.number;
    }
  } else {
    return null;
  }
};

export const telephoneNumber = (text) => {
  var telephoneNumberTest = /^([0-9()/+ -]*)$/
  if (text) {
    if (telephoneNumberTest.test(text)) {
      return null;
    } else {
      return ErrorMessages.telephoneNumber;
    }
  } else {
    return null;
  }
};

export const dutchZipCode = (text, state) => {
  var zipCodeTest = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
  if (text) {
    if (zipCodeTest.test(text) || state.CountryCode !== "NL") {
      return null;
    } else {
      return ErrorMessages.dutchZipCode;
    }
  } else {
    return null;
  }
};

export const email = (text) => {
  if (text) {
    if (EmailValidator.validate(text)) {
      return null;
    } else {
      return ErrorMessages.email;
    }
  } else {
    return null;
  }
};

export const IBAN = (text) => {
  if (text) {
    if (checkIBAN.isValid(text)) {
      return null;
    } else {
      return ErrorMessages.IBAN;
    }
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/validation/validations.jsx